import axios from "axios";
import { ChangeEvent, useState } from "react";
import { Input, Dialog } from "react-weui-ts";
import { Handler } from "../common/handler";
import { getUrlParam } from "../utils/helpers";
import { base_url } from "../config";

interface SaveDialogProps {
  show: boolean;
  close: () => void;
  handler: Handler | null;
  title: string;
}

const SaveDialog = ({ show, close, handler, title }: SaveDialogProps) => {
  const [name, setName] = useState("");

  const submitToApi = () => {
    const id: string | null = getUrlParam("id");
    const openid: string | null = getUrlParam("openid");
    axios
      .post(`${base_url}/staff-store`, {
        id,
        title: name,
        openid,
        score: handler?.getScoreData(),
      })
      .then((res: any) => {
        const uuid = res.data?.data?.score_uuid;

        if (uuid && id === null) {
          window.location.href = `/?openid=${openid}&id=${uuid}`;
          return;
        }
      })
      .finally(() => {
        close();
      })
      .catch((e) => {
        alert("保存失败，请重试");
      });
  };

  const buttons = [
    {
      label: "取消",
      onClick: () => {
        console.log("取消");
        close();
      },
      style: {
        color: "#666",
        background: "#F7F7F7",
        borderRadius: "10px",
        margin: "10px 15px 10px 15px",
      },
    },
    {
      label: "确定",
      onClick: () => {
        submitToApi();
      },
      style: {
        color: "#fff",
        background: "#DFAE4B",
        borderLeft: "none",
        borderRadius: "10px",
        margin: "10px 15px 10px 15px",
      },
    },
  ];

  return (
    <Dialog type="ios" title={"乐谱名称"} buttons={buttons} show={show}>
      <Input
        style={{
          border: "1px solid #DCDCDC",
          padding: "10px",
          width: "calc(100% - 20px)",
          borderRadius: "5px",
          marginTop: "10px",
        }}
        defaultValue={title}
        onChange={(e: ChangeEvent) => {
          let titleInput = e.target as HTMLInputElement;
          const title = titleInput.value;
          setName(title);
        }}
        placeholder="请输入乐谱名字"
      />
    </Dialog>
  );
};

export default SaveDialog;
